export default "__VITE_ASSET__C$pJNGmd__"